var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',[_c('v-dialog',{attrs:{"max-width":"450"},model:{value:(_vm.promptDeleteHome),callback:function ($$v) {_vm.promptDeleteHome=$$v},expression:"promptDeleteHome"}},[_c('home-delete')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }